// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { PRIVATE, ADMIN } from 'router/routes';
import { useUser } from 'utils/contexts/app-context';
import { useFlags } from 'providers/FlagsProvider';
import FeatureFlags from 'utils/feature-flags';
import logo from '../../assets/images/logo.png';
import PageSelector from './page-selector';
import styles from './styles.module.scss';

import ProfilePictureWithDropdown from './profile-picture-with-dropdown';
import SearchBar from './search-bar';

type Props = {};

/**
 * Component representing the sticky navbar
 */
const NavBar = (_props: Props) => {
  const user = useUser();
  const { t } = useTranslation();
  const { matchedFlags } = useFlags({
    authorizedFlags: [
      FeatureFlags.AllowDelegates,
      FeatureFlags.AllowDashboard,
      FeatureFlags.AllowTalents,
      FeatureFlags.AllowValidations,
    ],
  });

  const pages = [
    {
      name: t('nouns.dashboard'),
      route: PRIVATE.dashboard,
      flag: FeatureFlags.AllowDashboard,
    },
    {
      name: t('nouns.talent_plural'),
      route: PRIVATE.talents,
      flag: FeatureFlags.AllowTalents,
    },
  ];

  const userType = _.get(user, ['employments', '0', 'user_type']);
  const pagesToShow = pages.filter(page => {
    const inMatchedFlags = matchedFlags.includes(page.flag);

    if (page.route === ADMIN.delegates) {
      return userType === 'ADMIN' && inMatchedFlags;
    }

    return inMatchedFlags;
  });

  const getLogo = () => logo;

  return (
    <div className={styles.desktop_content}>
      <Link to={PRIVATE.dashboard}>
        <img className={styles.logo} src={getLogo()} alt="" />
      </Link>

      <SearchBar count={5} />

      <div className={styles.profile_slot}>
        <PageSelector pages={pagesToShow} />
        <ProfilePictureWithDropdown picture={user ? user.picture : null} />
      </div>
    </div>
  );
};

export default NavBar;
